import { PROJECT_PICKER_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { RichValue, StringValue } from '../../../value/types.tsx';
import type { TransformedProjectField, TransformedProjectOption } from '../types.tsx';

const getProjectValue: StringValue<TransformedProjectField> = (field) => field.value?.name ?? '';

export const projectStringValueHandler = {
	[PROJECT_PICKER_CF_TYPE]: getProjectValue,
};

const getProjectRichValue: RichValue<TransformedProjectField, TransformedProjectOption> = (field) =>
	field.value ?? null;

export const projectRichValueHandler = {
	[PROJECT_PICKER_CF_TYPE]: getProjectRichValue,
};
